import React from 'react';
import { buildSmugmugUrl, buildSmugmugSrcSet } from '../utils/image';

const routes = [
  {
    name: 'Hains Point',
    distance: '6 miles',
    description:
      'Our weekday staple: a flat, wind-ready loop that teaches pacing control and makes marathon effort feel automatic',
    gpx: 'https://www.strava.com/routes/3426624675690352028',
    imageId: 'qJb2ZBn',
  },

  {
    name: 'Dual Ferries',
    distance: '10 miles',
    description:
      'A 10-mile loop in Maryland and our favorite test when the team is building for majors',
      gpx: 'https://www.strava.com/segments/23264376',
    imageId: '7vCd5NB',
  },
  {
    name: 'Dojo Big Loop',
    distance: '19 miles',
    description:
      '19 miles up Rock Creek and Beach Drive and down the Capital Crescent Trail',
    gpx: 'https://www.strava.com/segments/33069871',
    imageId: 'kDgPPL5',
  },
];

const cdnImageIds = [
  '9pgBdLf',
  'Z47w9sz',
  '8JVbvFV',
  '94MDf4r',
  'dTtWbBt',
  'FWcmsLn',
  '7MNzDm8',
  'nWLJN4J',
];

const galleryImages = cdnImageIds.map((imageId, index) => ({
  imageId,
  alt: `Dojo gallery photo ${index + 1}`,
}));

const galleryImageSizes = '(max-width: 640px) 100vw, (max-width: 900px) 50vw, 25vw';
const cardImageSizes = '(max-width: 640px) 100vw, (max-width: 960px) 50vw, 33vw';

export default function Routes() {
  return (
    <section className="page philosophy-page">
      <header className="section-header centered serif">
      <h1 className='title'>Routes</h1>
      <p>DC is the most underrated major city for running, and Dojo takes advantage of every road, trail, and path. Hains Point, a three-mile loop along the Potomac, is our weekday training ground.
      </p>

      </header>

      <div className="routes-grid">
        {routes.map(({ name, distance, description, terrain, gpx, imageId }) => (
          <article key={name} className="route-card">
            <div className="route-card__image">
              <img
                src={buildSmugmugUrl(imageId, 'L')}
                srcSet={buildSmugmugSrcSet(imageId)}
                sizes={cardImageSizes}
                alt={`${name} route preview`}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="route-card__body">
              <div className="route-card__meta">
                <h2 className="route-card__name">{name}</h2>
              </div>
              <p>{description}</p>
              {gpx && (
                <a
                  className="route-card__link"
                  href={gpx}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {name} GPS
                </a>
              )}
            </div>
          </article>
        ))}
      </div>

      <div className="gallery-row">
        {galleryImages.map(({ imageId, alt }) => (
          <figure key={imageId}>
            <img
              src={buildSmugmugUrl(imageId, 'L')}
              srcSet={buildSmugmugSrcSet(imageId)}
              sizes={galleryImageSizes}
              alt={alt}
              loading="lazy"
              decoding="async"
            />
          </figure>
        ))}
      </div>
    </section>
  );
}
